'use client'

import YoutubePlayer from 'react-player/youtube'
import HgAspectRatio from '~/design-system/hg/components/HgAspectRatio'

export type HgYoutubeEmbedProps = {
  url: string
}

export const HgYoutubeEmbed = ({url}: HgYoutubeEmbedProps) => (
  <HgAspectRatio classNames={{assetWrapper: 'rounded-none'}} aspectRatio="16:9">
    <YoutubePlayer data-chromatic="ignore" url={url} width="100%" height="100%" />
  </HgAspectRatio>
)
